import { ReactNode, useRef } from 'react';
import { ScrollView } from 'react-native';
import { FormScrollContext } from './FormScrollContext';

interface Props {
  children: ReactNode;
}

export function FormScrollProvider({ children }: Props) {
  const scrollView = useRef<ScrollView>(null);
  return <FormScrollContext.Provider value={scrollView}>{children}</FormScrollContext.Provider>;
}
